type Color = {
  id: string;
  displayName: string;
  systemName: string;
};

export const getColorHexCode = (id: string, colors: Color[]): string => {
  const colorMap: { [key: string]: string } = {
    blue: "#0000FF",
    black: "#000000",
    white: "#FFFFFF",
    grey: "#808080",
    red: "#FF0000",
    pink: "#FFC0CB",
    green: "#008000",
    brown: "#A52A2A",
    yellow: "#FFFF00",
    gold: "#FFD700",
    natural: "#F5F5DC",
    cream: "#FFFDD0",
    offwhite: "#FAF9F6",
  };

  const color = colors.find((color) => color.id === id);

  return color ? colorMap[color.systemName] || "#000000" : "#000000";
};
